import { URL_LANGUAGES } from 'tradera/lang/constants.mjs';

/**
 * Note: this expects to be called with window.location.pathname, so it will not handle
 * query parameters.
 */
export const isOnStartPage = (pathname: string) => {
    const isRootPath = pathname === '/';
    const fashionPath = '/fashion';
    const pokemonPath = '/pokemon';
    const isFashionPath = pathname === fashionPath;
    const isPokemonPath = pathname === pokemonPath;
    const isLocalePath = URL_LANGUAGES.some((lang) => pathname === `/${lang}`);

    return isRootPath || isFashionPath || isPokemonPath || isLocalePath;
};
